import CONSTANTS from '../../util/constants';

const initState = {
    isLoading: false,
    getDepartmentData: [],
    editDepartmentData: [],
    createDepartmentData: []
}

const DepartmentReducer = (state = initState, { type, payload }) => {

    switch (type) {
        case CONSTANTS.CONSTANTS_DEPARTMENT_MANAGEMENT.GET_DEPARTMENT_API_SUCCESS:
            return {
                ...state,
                getDepartmentData: payload.value
            }

        case CONSTANTS.CONSTANTS_DEPARTMENT_MANAGEMENT.EDIT_DEPARTMENT_API_SUCCESS:
            return {
                ...state,
                editDepartmentData: payload.value
            }

        case CONSTANTS.CONSTANTS_DEPARTMENT_MANAGEMENT.ADD_DEPARTMENT_API_SUCCESS:
            return {
                ...state,
                createDepartmentData: payload.value
            }
        default:
            return state
    }
}

export default DepartmentReducer;
